import React from "react";
import "./SelectAllCheckbox.css";

interface Props {
  /** The ids currently DISPLAYED in this leaf (already search-filtered). */
  ids: number[];
  selectedIds: Set<number>;
  onToggle: (ids: number[]) => void;
}

/** "Select all shown" for a leaf (a level, or the untagged group). Checked when
 *  every displayed row is selected, indeterminate when some are. Only ever acts
 *  on `ids` — i.e. exactly what the search is showing. */
const SelectAllCheckbox: React.FC<Props> = ({ ids, selectedIds, onToggle }) => {
  const ref = React.useRef<HTMLInputElement>(null);
  let selCount = 0;
  for (const id of ids) if (selectedIds.has(id)) selCount += 1;
  const all = ids.length > 0 && selCount === ids.length;
  const some = selCount > 0 && !all;

  React.useEffect(() => {
    if (ref.current) ref.current.indeterminate = some;
  }, [some]);

  return (
    <input
      ref={ref}
      type="checkbox"
      className="takt-editor-selectall"
      checked={all}
      disabled={ids.length === 0}
      draggable={false}
      onClick={(e) => e.stopPropagation()}
      onChange={() => onToggle(ids)}
      title="Select all shown"
      aria-label="Select all shown"
    />
  );
};

export default SelectAllCheckbox;
